var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"positionAdress"}},[_c('span',[_vm._v(_vm._s(_vm.position_adress_data || '定位中'))])])}
var staticRenderFns = []

export { render, staticRenderFns }